import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

import Home from "./user/pages/Home";
import About from "./user/pages/About";
import Category from "./user/pages/Category";
import Blog from "./user/pages/Blog";
import AllBlogs from "./user/pages/AllBlogs";
import Contact from "./user/pages/Contact";
import UserLogin from "./user/pages/UserLogin";
import UserSignup from "./user/pages/UserSignup";
import MyBlogs from "./user/pages/MyBlogs";
import CreateBlogs from "./user/pages/CreateBlogs";
import Product from "./user/pages/Product";
import ProductSlug from "./user/pages/ProductSlug";
import Checkout from "./user/pages/Checkout";
import AccountOrder from "./user/pages/account/AccountOrder";
import AccountOrderView from "./user/pages/account/AccountOrderView";
import Accountprofile from "./user/pages/account/Accountprofile";
import AccountPassword from "./user/pages/account/AccountPassword";
import AccountSupport from "./user/pages/account/AccountSupport";
import AccountPlan from "./user/pages/account/AccountPlan";
import Account from "./user/pages/account/Account";
import AccountAllEnquire from "./user/pages/account/AccountAllEnquire";
import AccountAllTransactions from "./user/pages/account/AccountAllTransactions";
import CartPage from "./user/pages/Cart";
import CompleteOrder from "./user/pages/CompleteOrder";
import WishList from "./user/pages/WishList";
import Comparsion from "./user/pages/Comparsion";
import Page from "./user/pages/Page";
import Cancel from "./user/pages/Cancel";
import SignupUserType from "./user/pages/SignupUserType";

import ErrorPage from "./user/pages/ErrorPage";

import { Toaster } from "react-hot-toast";

import { BlogProvider } from "./fetchdata/BlogContext";

import usePreventZoom from "./helper/usePreventZoom";
import getCookie from "./helper/getCookie";
import AllVendors from "./user/pages/vendor/AllVendors";
import ViewVendor from "./user/pages/vendor/ViewVendor";
import getDecryptData from "./helper/getDecryptData";
import AllPlans from "./user/pages/vendor/AllPlans";
import CheckoutPlan from "./user/pages/CheckoutPlan";
import CardView from "./user/pages/CardView";
import SuccessPage from "./user/pages/vendor/SuccessPage";
import FailPage from "./user/pages/vendor/FailPage";
import AccountprofileNew from "./user/pages/account/AccountprofileNew";
import HomeLocation from "./user/pages/HomeLocation";
import VendorLayout from "./user/pages/vendor/VendorLayout";
import AccountCreate from "./user/pages/account/AccountCreate";
import SearchListing from "./user/pages/SearchListing";
import SearchVendorListing from "./user/pages/SearchVendorListing";
import HomeCartLocation from "./user/pages/HomeCartLocation";
import HomeMain from "./user/pages/HomeMain";
import PatnerPage from "./user/pages/PatnerPage";
import HomeCartLocationProduct from "./user/pages/HomeCartLocationProduct";
import FindFriend from "./user/pages/FindFriend";
import ProfileView from "./user/pages/ProfileView";
import AccountChat from "./user/pages/account/AccountChat";
import AccountRequest from "./user/pages/account/AccountRequest";
import AccountFriends from "./user/pages/account/AccountFriends";
import TestingHome from "./user/pages/testing/TestingHome";
 
const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

function App() {


  const location = useLocation(); // Get the current location from React Router
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    isLoginFromLocalStorage
  );

  const [isUsertype, setisUsertype] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsUserAuthenticated(isLoginFromLocalStorage);
      const mydata = await getDecryptData();
      if (mydata) {
        const mydatatype = mydata.type;
        setisUsertype(mydatatype);
      }

      console.log("mydata", mydata, isLoginFromLocalStorage);

      window.scrollTo(0, 0);
      const timeoutId = setTimeout(() => {
        // const rootElement = document.getElementById("root");
        // if (rootElement.innerHTML === "") {
        //   navigate("/error", { replace: true });
        //   window.location.reload();
        //   setIsError(true);
        //   console.log("error found");
        // }
        // console.log(" found", rootElement);
      }, 1000); // Adjust the timeout duration as needed

      return () => clearTimeout(timeoutId);
    };

    fetchData();
  }, [isLoginFromLocalStorage, location.pathname]);

  return (
    <>
      <BlogProvider>
        <Toaster />

        <Routes>

                   <Route path="/" element={<TestingHome />} /> 

          {/* <Route path="/about" element={<About />} /> 
              <Route path="/contact" element={<Contact />} />

          <Route path="/allblogs" element={<AllBlogs />} />
          <Route
            path="/login"
            element={<UserLogin updateAuthStatus={setIsUserAuthenticated} />}
          />
          <Route path="/signup" element={<UserSignup />} />
          <Route path="/blog/:slug" element={<Blog />} />

          <Route path="/product/:id" element={<Product />} />
          <Route path="/product/:slug/" element={<ProductSlug />} />

          <Route
            path="/checkout"
            element={<Checkout updateAuthStatus={setIsUserAuthenticated} />}
          />
          <Route path="/cart" element={<CartPage />} />
     <Route path="/complete-order" element={isUserAuthenticated ? <CompleteOrder /> : <Navigate to="/login" />} />  

 
          <Route
            path="/wishList"
            element={
              isUserAuthenticated ? <WishList /> : <Navigate to="/login" />
            }
          />

          <Route
            path="/comparsion"
            element={
              isUserAuthenticated ? <Comparsion /> : <Navigate to="/login" />
            }
          />

          <Route
            path="/account"
            element={
              isUserAuthenticated ? <Account /> : <Navigate to="/login" />
            }
          />
          <Route
            path="/account/order/:userId/:orderId"
            element={
              isUserAuthenticated ? (
                <AccountOrderView />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route path="/account/plan"
            element={
              isUserAuthenticated ? (
                <AccountPlan />
              ) : (
                <Navigate to="/login" />
              )

            }
          />


          <Route
            path="/account/profile"
            element={
              isUserAuthenticated ? (
                <Accountprofile />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/account/profile-kyc"
            element={
              isUserAuthenticated ? (
                <AccountprofileNew />
              ) : (
                <Navigate to="/login" />
              )
            }
          />




          <Route
            path="/account/password"
            element={
              isUserAuthenticated ? (
                <AccountPassword />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/account/support"
            element={
              isUserAuthenticated ? (
                <AccountSupport />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/account/all-enquire"
            element={
              isUserAuthenticated ? (
                <AccountAllEnquire />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/account/all-transactions"
            element={
              isUserAuthenticated ? (
                <AccountAllTransactions />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
   <Route
            path="/account/create"
            element={ <AccountCreate />  }
          />
  <Route
            path="/shop-list/:term"
             element={<SearchListing />} />

 <Route   path="/seller-list/:term"  element={<SearchVendorListing />} />


          <Route path="/cancel" element={<Cancel />} />

 
          <Route path="/" element={<Home />} />
         <Route path="/home/:slug" element={<HomeMain />} />
          <Route path="/home" element={<HomeMain />} />

          <Route path="/user-patner" element={<PatnerPage />} />

           <Route path="/account/request" element={<AccountRequest />} />
           <Route path="/account/friends" element={<AccountFriends />} />

          
         <Route path="/chat/:userId" element={<AccountChat />} />



        <Route path="/profile/:id" element={<ProfileView />} />
 
          <Route path=":location/:id" element={<Category />} />
          <Route path="/partner/:slug" element={<PatnerPage />} />

          <Route path="page/:slug" element={<Page />} />
          <Route path="/seller/:id" element={<VendorLayout />} />
          <Route path="/shop-cart" element={<HomeCartLocation />} />
          <Route path="/shop/:loc/:slug" element={<HomeCartLocationProduct />} />



          <Route path="/signup-user" element={<SignupUserType />} />

                <Route path="/complete-order" element={
              isUserAuthenticated ? <CompleteOrder /> : <Navigate to="/login" />
            } />
    <Route path="/account/all-order" element={
              isUserAuthenticated ? <AccountOrder /> : <Navigate to="/login" />
            } />
            
          <Route path="/checkout-plan/:id" element={<CheckoutPlan />} />
        <Route path="/find-friend" element={ isUserAuthenticated ?  <FindFriend /> : <UserLogin updateAuthStatus={setIsUserAuthenticated} /> } />


            
       <Route path="/all-vendor" element={<AllVendors />} />
          <Route path="/vendor/:id" element={<ViewVendor />} />
          <Route path="/card-view/:id" element={<CardView />} />


          <Route path="/all-plan" element={<AllPlans />} />  


          <Route path="/404" element={<ErrorPage />} />
          <Route path="/payment-success/:id" element={<SuccessPage />} />

          <Route path="/payment-fail/" element={<FailPage />} /> 

          <Route path="/all-plan" element={<AllPlans />} />  


          <Route path="*" element={<ErrorPage />} /> */}


        </Routes>
        <ScrollToTop />
      </BlogProvider>
    </>
  );
}

export default App;
